export default {"src":"/_next/static/media/shareTwitGrey.d9d44e46.svg","height":32,"width":32};